<template>
  <nx-taxonomy-form-selector
    v-bind="$attrs"
    :auth="contentAuth"
    v-on="$listeners"
  />
</template>

<script>
import NxTaxonomyFormSelector from '@/modules/taxonomy/selector/FormSelector';

export default {
  name: 'NxContentTaxonomyFormSelector',
  components: { NxTaxonomyFormSelector },
  inject: ['$entityId'],
  props: {
    contentId: {
      type: [Number, String],
    },
    ignorePermissions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    id() {
      if (this.contentId) {
        return this.contentId;
      }
      return this.$entityId;
    },
    contentAuth() {
      return {
        actions: {
          // Specify bbnx operation when adding taxonomies for validation
          ADD: this.ignorePermissions ? null : 'content.add_taxonomy',
          // Specify bbnx operation when removing current taxonomies
          DELETE: this.ignorePermissions ? null : 'content.remove_taxonomy',
        },
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
